'use strict';

import modalExport from './modal';
const modal = modalExport.global;
import validator from './validator';
import analytics from './analytics';
import util from './util';

var memScroll = 0;
var myDoc = null;
var myPolChk = '';
var myPolicy = null;
var mySrc = null;
var nowRegistered = false;
var reclickMe = null;
var id_to_toggle = '#nothing';
var recursionlevel = 0;

// ---------------- for desktop
$('.btnMB, .view-reqs, .openit').click(function () {
    // if mobile, go away
    //if ($(window).outerWidth(true) < 768) { return; };
    id_to_toggle = '#' + $(this).data('tgtelem');

    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();
    // 1032
    if ($(window).width() >1024) {
        $('.pt_content').css('height', 'auto');
        $('.narspro_join .npMenu .tal').css('width', '340px');
    }
    // if it's open, just close it
    if ($(id_to_toggle).is(':visible')){
        $(id_to_toggle).slideUp(slideUpSpeed);
        if ($(window).width() >768 && $('.options-container').length) {
            $(id_to_toggle).prevAll().eq(1).find('.closeit').hide();
            $(id_to_toggle).prevAll().eq(1).find('.openit').show();			
        }
        $(id_to_toggle).prev().find('.closeit').hide();
        $(id_to_toggle).prev().find('.openit').show();
        return;
    }

    // close all others
    closeAll();
    $(id_to_toggle).slideDown(slideDownSpeed);
    $(id_to_toggle).prev().find('.openit').hide();
    $(id_to_toggle).prev().find('.closeit').show();
    if ($(window).width() >768 && $('.options-container').length) {
        $(id_to_toggle).prevAll().eq(1).find('.openit').hide();
        $(id_to_toggle).prevAll().eq(1).find('.closeit').show();
    }
    $('.bottomtext').removeClass('upload-bottom-text1 upload-bottom-text2 upload-bottom-text3');
})


$('.view2').on('click', function() {
    $('.bottomtext').removeClass('push-view1 push-view3');
    $('.bottomtext').toggleClass('push-view2');
});

$('.view1').on('click', function() {
    $('.bottomtext').removeClass('push-view2 push-view3');
    $('.bottomtext').toggleClass('push-view1');
});

$('.view3').on('click', function() {
    $('.bottomtext').removeClass('push-view1 push-view2');
    $('.bottomtext').toggleClass('push-view3');
});


$('.reqs-link, .explore').click(function () {
    // if Big, go away
    if (767 < $(window).outerWidth(true)) { return; }
    id_to_toggle = '#' + $(this).data('myelem');
    // 1051
    // if it's open, just close it
    if ($(this).find('.closeit').is(':visible')) {
        $(id_to_toggle).slideToggle(600);
        $(this).find('.closeit').hide();
        $(this).find('.openit').show();
        return;
    }

    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();

    // close all others
    //	closeAll();

    $(this).next().slideToggle(600);
    if ($(this).find('.openit').is(':visible')) {
        $(this).find('.openit').hide();
        $(this).find('.closeit').show();
    }
});
//-----------------------
$('.appnow').click(function (e) {
    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();
    $('.inputUrlSection').hide();

    // clear all inputs
    $('input.inputfile').val('');
    $('input.disableInputField').val('');
    $('input.hidehint').val('');
    mySrc = null;
    $('input[name=UorM]').parent().removeClass('checked');
    id_to_toggle = '#' + $(this).data('tgtelem');
    $('.bottomtext').removeClass('upload-bottom-text1 upload-bottom-text2 upload-bottom-text3');
    $('.bottomtext').removeClass('push-view1 push-view2 push-view3');
    $('.bottom-text-mobile').css('margin-top', '0px');
    reclickMe = null;
	
    if ($(window).width() >1024) {
        $('.pt_content').css('height', 'auto');
        $('.narspro_join .npMenu .tal').css('width', '340px');
    }
	

    // if it's open, uncheck options, and close it
    if ($(id_to_toggle).is(':visible')) {
        $('input:checkbox').removeAttr('checked');
        $('.icheckbox_icon').removeClass('checked'); // two ways, in case the plug-in is active
        $('.privactual').hide();
        $('.mailOrUpload').hide();
        $(id_to_toggle).slideUp(slideUpSpeed);
        $('.bottom-text-mobile').css('margin-top', '0px');
        $('.bottomtext').removeClass('upload-bottom-text1 upload-bottom-text2 upload-bottom-text3');
        return;
    }
    closeAll();

    if (!isRegistered(nowRegistered)) {
        var loginURL = Urls.showLogin + '?original=' + $(this).data('url')
        memScroll = window.scrollY;
        window.scrollTo(0, 0);
        modal.restoreDefaultClass();
        modal.addCustomClass('login-modal noGuest');
        modal.renderByUrl(loginURL);
       	modal.setCallback(function() {
            validator.initForm('#modal-cntr #dwfrm_login');
        });
        reclickMe = $(this);
    } else {
        if (0 < memScroll) { window.scrollTo(0, memScroll); memScroll = 0;}
        // show the Apply stuff
        window.location.href = $(this).data('url');
    }
});
// ----------------
$('.closeit').click(function () {
    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();

    $('#' + $(this).data('tgtelem')).slideUp(slideUpSpeed);
    $(this).hide();
    $(this).prev().show();
    if ($('.options-container').length) {
        $(this).prev().find('.openit').show();
    }
})
//-----------------------
$('.pro-modal-link').click(function(e) {
    e.preventDefault();
    $('#narspromodal').dialog({
        height: 341,
        modal: true,
        width: 974,	
    });
    if (screen.width >= 768) {
        $('html, body').animate({scrollTop: 0}, 100);
	    return false;
    }
	
    $('.ui-widget-overlay').click(function(){
        $('.ui-dialog-titlebar-close').click();
    });
});
// ----------------------------------- closeAll
function closeAll() {
    $('.closeit').each(function() {
        if ($(this).is(':visible')) {
            $(this).click();
        }
    });
    closeOne('#MB01');
    closeOne('#appapd');
    closeOne('#appind');
    closeOne('#appard');
    closeOne('#reqapd');
    closeOne('#reqind');
    closeOne('#reqard');
}

// ----------------------------------- closeOne
function closeOne(elemID) {
//	if ($(elemID).is(":visible")) { $(elemID).slideUp(slideUpSpeed); }
    $(elemID).slideUp(slideUpSpeed);
}
// -----------------------------------
var delayMillis = 6000; // 1000 = 1 second
var fadeMillis = 2000;
var slideUpSpeed = 600;
var slideDownSpeed = 600;

// ----------------------------------- cycle the images
function CycleImgs() {
    if (767 < $(window).width()) {
        setTimeout(function() {
            $('#slideshow .bgM02').fadeTo(fadeMillis, 0.3);
            $('#slideshow .bgM01').fadeTo(fadeMillis, 0);
            setTimeout(function() {
                $('#slideshow .bgM03').fadeTo(fadeMillis, 0.3);
                $('#slideshow .bgM02').fadeTo(fadeMillis, 0);
                setTimeout(function() {
                    $('#slideshow .bgM01').fadeTo(fadeMillis, 0.3);
                    $('#slideshow .bgM03').fadeTo(fadeMillis, 0);
                }, delayMillis);
            }, delayMillis);
        }, delayMillis);
        // and schedule a repeat
        setTimeout(CycleImgs, 3 * delayMillis);
    }
}

// start the cycle - trying instead, on hover
//CycleImgs();

// ----------------------------------- click() to open or close a section on mobile
$('.apply-btn-m, .openitm, .closeitm').click(function () {
    var userClicked = this; // "this" may change
    if (0 < memScroll) { window.scrollTo(0, memScroll); memScroll = 0;}
    id_to_toggle = '#' + $(userClicked).data('tgtelem');

    // if not mobile, ignore click
    if (767 < $(window).outerWidth(true)) { return; }

    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();
    $('.inputUrlSection').hide();

    // clear previous values
    myDoc = null;
    myPolChk = ''
    myPolicy = null;
    mySrc = null;

    // check for login?
    if (id_to_toggle.substr(1, 3) == 'app') {
        if (!isRegistered(nowRegistered)) {
            memScroll = window.scrollY;
            window.scrollTo(0, 0);
            // open the login modal
            var params = {
                url : Urls.NarsProLogin,
                options: {
                    width : 960,
                    height: 900,
                    dialogClass: 'login-modal noGuest'
                },
                callback : function () {
                    app.account.init();
                    initLoginFormSubmit();
                    initRegisterFormSubmit();
                }
            };
            app.dialog.open(params);
            reclickMe = $(userClicked);
            return;
        }
    }

    // if it's open, just close it (and deeper levels)

    if ($(id_to_toggle).is(':visible')) {
        doAClose(id_to_toggle);
        return;
    } // done if ($(id_to_toggle).is(":visible"))

    // if we get here, it was closed, so we must open it

    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();

    // if level 1, close other level 1s
    if (id_to_toggle == '#reqapm') {
        if ($('#ClosIndu').is(':visible')) { doAClose($('#ClosIndu').data('tgtelem')); }
        if ($('#ClosArti').is(':visible')) { doAClose($('#ClosArti').data('tgtelem')); }
    }
    if (id_to_toggle == '#reqinm') {
        if ($('#ClosAppr').is(':visible')) { doAClose($('#ClosAppr').data('tgtelem')); }
        if ($('#ClosArti').is(':visible')) { doAClose($('#ClosArti').data('tgtelem')); }
    }
    if (id_to_toggle == '#reqarm') {
        if ($('#ClosAppr').is(':visible')) { doAClose($('#ClosAppr').data('tgtelem')); }
        if ($('#ClosIndu').is(':visible')) { doAClose($('#ClosIndu').data('tgtelem')); }
    }

    $(id_to_toggle).addClass('show-on-mobile');
    $(id_to_toggle).slideDown(slideDownSpeed);
    $(userClicked).parent().find('.openitm').first().hide();
    $(userClicked).parent().find('.closeitm').first().show();

});
// ----------------------------------- doAClose
function doAClose(pElem) {
    pElem = ('#' + pElem).replace('##', '#');
    var id_to_close = pElem;
    if ($(id_to_close).is(':visible')) {
        // close the 3s that are deeper
        $(id_to_close + ' .closeitm.level3').each(function() {
            if ($(this).is(':visible')) {
                toclose = '#' + $(this).data('tgtelem');
                $(toclose).slideUp(slideUpSpeed);
                $(toclose).removeClass('show-on-mobile');
                $(this).parent().find('.closeitm').first().hide();
                $(this).parent().find('.openitm').first().show();
            }
        });
        // close the 2s that are deeper
        $(id_to_close + ' .closeitm.level2').each(function() {
            if ($(this).is(':visible')) {
                toclose = '#' + $(this).data('tgtelem');
                $(toclose).slideUp(slideUpSpeed);
                $(toclose).removeClass('show-on-mobile');
                $(this).parent().find('.closeitm').first().hide();
                $(this).parent().find('.openitm').first().show();
            }
        });
        // close this one
        $(id_to_close).slideUp(slideUpSpeed);
        $(id_to_close).removeClass('show-on-mobile');
        if ($(pElem).is('#reqapm, #reqinm, #reqarm')) {
            $(pElem).parent().find('.closeitm').first().hide();
            $(pElem).parent().find('.openitm').first().show();
        }
        if ($(pElem).is('#appapm, #appinm, #apparm')) {
            $(pElem).prev().find('.closeitm').first().hide();
            $(pElem).prev().find('.openitm').first().show();
        }
    }
    return
}
// ----------------------------------- closeOnem
function closeOnem(elemID) {
    $(elemID).slideUp(slideUpSpeed);
    $(elemID).removeClass('show-on-mobile');
    // adjust arrows?
}

// ----------------------------------- initLoginFormSubmit (these are copied from Skedge code)
function initLoginFormSubmit() {
    $('[id$=_login]').on('submit', function(e) {
        e.preventDefault(e);
        loginForm();
    });
}
// ----------------------------------- initRegisterFormSubmit
function initRegisterFormSubmit() {
    $('[id$=_login_register]').on('submit', function(e) {
        e.preventDefault(e);
        registerForm();
    });
}
// ----------------------------------- clearPPError
function clearPPError(elem) {
    $(elem).closest('.NPError').removeClass('NPError');
    $('.errPP').remove();
}
// ----------------------------------- loginForm
function loginForm() {
    var form = $('[id$=_login]');
    if(!form.valid()){
        return;
    }
    var url = app.util.appendParamToURL(form.attr('action'), 'format', 'ajax');
    var target = $('.returning-customers');
    var data = form.serialize() + '&' + $('[name$=_login_login]').attr('name') + '=login'; // yes, it's twice
    $.ajax({
        url : url,
        data: data,
        type: 'POST'
    }).done(function(response) {
        var obj = jQuery.parseJSON(response);
        if (!obj.success) {
            $('.error-form').remove();
            $('form#dwfrm_login').prepend('<div class=\'error-form\'>' + app.resources.LOGINERROR + '<br></div>');
            return;
        }
        firstName = obj.firstName;
        lastName = obj.lastName;
        email = obj.email;
        phone = obj.phone;
        sendCustomerData();
        app.dialog.close();
        nowRegistered = true;
        $('a.user-login').text('My Account');
        $(reclickMe).click();
    });
}
// ----------------------------------- registerForm
function registerForm() {
    var form = $('[id$=_login_register]');
    if(!form.valid()){
        return;
    }
    var url = app.util.appendParamToURL(form.attr('action'), 'format', 'ajax');
    var target = $('.login-create-account');
    var data = form.serialize() + '&' + $('[name$=_login_register]').attr('name') + '=login';
    $.ajax({
        url : url,
        data: data,
        type: 'POST'
    }).done(function(response) {
        var obj = jQuery.parseJSON(response);
        if (obj.success) {
            firstName = obj.firstName;
            lastName = obj.lastName;
            email = obj.email;
            phone = obj.phone;
            sendCustomerData();
            app.dialog.close();
            nowRegistered = true;
            $('a.user-login').text('My Account');
            $(reclickMe).click();
        } else {
            $('.error-form').remove();
            $('form#dwfrm_login_register').prepend('<div class=\'error-form\'>Registration failed. Either a username for that e-mail address already exists, or your inputs don\'t match each other.<br></div>');
            return;
        }
    });
}
// ----------------------------------- sendCustomerData
function sendCustomerData(){
    var customerData = {
        'type': 'response',
        'resource': 'user',
        'data': {
            'email': email,
            'firstName': firstName,
            'lastName': lastName,
            'phone': phone
        }
    }
}
// ----------------------------------- myOwnChk
function myOwnChk(elem) {
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();
    bWasChecked = elem.checked;
    // uncheck all
    //$("input:checkbox").removeAttr("checked");
    //$(".icheckbox_icon").removeClass("checked");
    // toggle this from old value
    //elem.checked = !bWasChecked;
    mySrc = null;
    myPolicy = null;
    myDoc = null;
    if (!bWasChecked) {
        $('.hasfilename').val('');
        $(elem).parent().find('.icheckbox_icon').removeClass('checked');
        $('.mailOrUpload').slideUp(slideUpSpeed);
        $('.privactual').slideUp(slideUpSpeed);
        $('.inputUrlSection').hide();
        //$(".bottomtext-tab").css("margin-top", "0px");
        $('.bottom-text-mobile').css('margin-top', '0px');
        if ($(window).width() >1024) {
            $('.pt_content').css('height', 'auto');
            $('.narspro_join .npMenu .tal').css('width', '340px');
        }

    } else {
        // update the submit link
        myPolicy = $(elem).closest('.chx').siblings('.privactual');
        myPolChk = $(myPolicy).find('.icheckbox_icon');
        // show what we need
        $(elem).closest('.chx').siblings('.privactual').show();
        //$(".bottomtext-tab").css("margin-top", "793px");
        if ($(window).width() >1024) {
            $('.pt_content').css('height', '1600px');
        }
        if ($(elem).hasClass('doUpload')) {
            $(elem).closest('.chx').siblings('.mailit').hide();
            $(elem).closest('.chx').siblings('.uploadit').show();
		    $('.narspro_join .npMenu .tal').css('width', 'auto'); 
            mySrc = 'upload';
        } else if ($(elem).hasClass('doMail')) {
            $(elem).closest('.chx').siblings('.uploadit').hide();
            $('.inputUrlSection').hide();
            $(elem).closest('.chx').siblings('.mailit').show();
            mySrc = 'mail';
        }
    }
    return true;
}


$('.join-us-apprentice-checkbox').on('click', function() {
    $('.bottomtext').removeClass('upload-bottom-text2 upload-bottom-text3');
    $('.bottomtext').toggleClass('upload-bottom-text1');
});

$('.join-us-industry-checkbox').on('click', function() {
    $('.bottomtext').removeClass('upload-bottom-text1 upload-bottom-text3');
    $('.bottomtext').toggleClass('upload-bottom-text2');
});

$('.join-us-artist-checkbox').on('click', function() {
    $('.bottomtext').removeClass('upload-bottom-text1 upload-bottom-text2');
    $('.bottomtext').toggleClass('upload-bottom-text3');
});


// ----------------------------------- myAttChk
function myAttChk(elem) {
    bWasChecked = elem.checked;
    // clear errors
    $('.errable').removeClass('NPError')
    $('.errmsg').remove();
    // uncheck all
    //$(".chooseDoc input:checkbox").removeAttr("checked");
    //$(".chooseDoc .icheckbox_icon").removeClass("checked");
    // toggle this from old value
    //elem.checked = !bWasChecked;
    if (!bWasChecked) {
        myDoc = null;
    } else if ($(elem).hasClass('chkAcl')) {
        myDoc = 'Cosmetic License';
    } else if ($(elem).hasClass('chkAus')) {
        myDoc = 'Union Card';
    } else if ($(elem).hasClass('chkAws')) {
        myDoc = 'Agency Website';
    } else if ($(elem).hasClass('chkCes')) {
        myDoc = 'Editorial Shoot';
    } else if ($(elem).hasClass('chkDcc')) {
        myDoc = 'Memo-Sheet-Contract';
    } else if ($(elem).hasClass('chkPoe')) {
        myDoc = 'Proof of Employment';
    } else if ($(elem).hasClass('chkPol')) {
        myDoc = 'Proof of LLC';
    } else if ($(elem).hasClass('chkPws')) {
        myDoc = 'Professional Website';
    } else if ($(elem).hasClass('chkSid')) {
        myDoc = 'Studnt ID';
    } else {
        myDoc = null;
    }
    if (elem.checked && (-1 < myDoc.indexOf('Webs'))) {
        $('.inputBtnSection.byUrl').hide();
        $('.inputUrlSection').show();
    } else {
        $('.inputUrlSection').hide();
        $('.inputBtnSection.byUrl').show();
    }
    return true;
}
// ----------------------------------- trySubmit
function trySubmit(that, myParam) {
    // myParam = "apd", "ind", ard", "apm", "inm", arm"
    var $form = $(that).closest('form');
	
    // clear all errors
    $('.errable').removeClass('NPError');
    $('.errmsg').remove();

    // can this even happen?
    var myAlert = 'You have been logged out.\nPlease log in again, to apply for NARS PRO.';
    if (!isRegistered(nowRegistered)) {
        alert(myAlert);
        window.location.reload(true);
        return false;
    }

    // from the bottom up
    var isPrivacyChecked = $form.find('.ofage').prop('checked');
	
	
    myTgt = ''; // assume all is good
    if (!isPrivacyChecked) {
        if ($('.privactual').is(':visible')) {
            myTgt = '.pp' + myParam;
            $(myTgt).addClass('NPError');
            $(myTgt + ' .errMsgHere').parent().after('<span class="errmsg errPP">You must agree to the Privacy Policy.</span>');
        }
    } else if (mySrc == 'mail') {
        // redirect to mail page
        // window.location.href = "$url('Page-Show', 'cid', 'nars-pro-mailin')$#ai"; // the old way
        window.location.href = '$url(\'NarsPro-SubmitMailin\')$' + '?myParam=' + myParam; // for new way
        return false;
    }

    if (mySrc != 'mail') {
        if (myDoc == null) {
            myTgt = '.chk' + myParam;
            $(myTgt).addClass('NPError');
            $(myTgt + ' .errMsgHere').parent().after('<span class="errmsg">Please select a second document type.</span>');

        } else if (-1 < myDoc.indexOf('Webs')) {
            if ($('.web' + myParam).val() == '') {
                myTgt = '.web' + myParam;
                $(myTgt).parent().addClass('NPError');
                $(myTgt).parent().find('.errMsgHere').parent().after('<span class="errmsg">Please fill in the URL.</span>');
            }
        } else {
            if ($('.file2' + myParam).val() == '') {
                myTgt = '.file2' + myParam;
                $(myTgt).parent().parent().addClass('errable NPError');
                $(myTgt).parent().parent().find('.errMsgHere').parent().after('<span class="errmsg">Please select a second document to upload.</span>');
            } else {
                $('#app' + myParam + ' form').append('<input type="text" class="visually-hidden" ' +
					'name="file2name" value="' + $('.file2' + myParam).val().split('/').pop().split('\\').pop() + '" /> ');
            }
        }

        if ($('.file1' + myParam).val() == '') {
            myTgt = '.file1' + myParam;
            $(myTgt).addClass('errable NPError');
            $(myTgt).parent().after('<span class="errmsg">Upload a copy of your Legal ID.</span>');
        }
	

        if (mySrc == null) {
            $('.errable').removeClass('NPError');
            myTgt = '.chx' + myParam;
            $(myTgt).addClass('NPError');
            $(myTgt + ' .errMsgHere').parent().after('<span class="errmsg">Please select Upload or Mail In.</span>');
        }
    }
    // ---------------------------------

    if (myTgt != '') {
        // already painted red
        $('html, body').animate({
            scrollTop: $(myTgt).offset().top - 100
        }, 700);
        return false;
    }

    $('#app' + myParam + ' form').append('<input class="visually-hidden" type="hidden" name="myDoc" value="' + myDoc + '" /> '); // long ver from checkbox label
    $('#app' + myParam + ' form').append('<input class="visually-hidden" type="hidden" name="myParam" value="' + myParam + '" /> ');
    $('#app' + myParam + ' form').append('<input class="visually-hidden" type="hidden" name="file1name" value="' + $('.file1' + myParam).val().split('/').pop().split('\\').pop() + '" /> ');

    $('#app' + myParam + ' form').submit();
}
// -----------------------------------
function js_yyyy_mm_dd_hh_mm_ss() {
    now    = new Date();
    year   = '' + now.getFullYear();
    month  = ('00' + (now.getMonth() + 1)).slice(-2);
    day    = ('00' +  now.getDate()).slice(-2);
    hour   = ('00' +  now.getHours()).slice(-2);
    minute = ('00' +  now.getMinutes()).slice(-2);
    second = ('00' +  now.getSeconds()).slice(-2);
    return year + month + day + hour + minute + second;
//	return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

function isRegistered(nowRegistered){
    if(window.User.isRegistered || nowRegistered){
        return true;
    } else {
        return false;
    }
	
}


if($('body').find('.narspro_wrap').length){
    $('body').addClass('narspro_joinus_forms_page');
    $('.pt_content').css('background', '#000');
} else if($('body').find('.narspro_wrap').length === 0){
    $('.pt_content').css('background','#fff');
}


$('.check-select').on('click', function() {
	  // in the handler, 'this' refers to the box clicked on
	  var $box = $(this);
	  if ($box.is(':checked')) {
	    // the name of the box is retrieved using the .attr() method
	    // as it is assumed and expected to be immutable
	    var group = 'input:checkbox[name=\'' + $box.attr('name') + '\']';
	    // the checked state of the group/box on the other hand will change
	    // and the current value is retrieved using .prop() method
	    $(group).prop('checked', false);
	    $box.prop('checked', true);
	  } else {
	    $box.prop('checked', false);
	  }
});


var needsUpdate = true;

//now in the timer task
if (needsUpdate) {
    $('td.pn_adm_jeff').children('div.dtxt').append('zzz');
    needsUpdate = false;
}


//narspro background slider

$('#joinus-slideshow').slick({
	  infinite: true,
	  speed: 500,
	  fade: true,
	  autoplay: true,
	  cssEase: 'linear',
	  dots: false,
	  prevArrow: false,
	  nextArrow: false	
		  
});
$('#joinus_mobile-slide').slick({
	  infinite: true,
	  speed: 500,
	  fade: true,
	  autoplay: true,
	  cssEase: 'linear',
	  dots: false,
	  prevArrow: false,
	  nextArrow: false		  
});
$('.nars-pro-step-1 .check-item-wrap').click(function(){
    $('.option-inner-wrap').removeClass('active-option');
    $(this).closest('.option-inner-wrap').addClass('active-option');
    $('a.np-next-step-button').removeClass('button-nonclickable');
});
if(!($('.nars-pro-step-1 input[name="radio"]').is(':checked'))) {
    $('a.np-next-step-button').addClass('button-nonclickable');
} else {
    $('a.np-next-step-button').removeClass('button-nonclickable');
}

$(document).on('click', '#nars-pro-stepOne', function () {
    var radioVal =  $('.nars-pro-step-1 input[name="radio"]:checked');	
    analytics.narsProStepOne(radioVal.attr('id'),'Step1');
    var nextLoc = radioVal.val();
    
    if (isRenew && isRenew === true) {
    	nextLoc = util.appendParamToURL(nextLoc, 'renew', 'true');
    }   
    location.href = nextLoc;
});
  
  
$('.material_input input.enhanced-input').each(function(){
    if(!this.value){
        $(this).removeClass('has-value');
    }else{
        $(this).addClass('has-value');
    }
});

$('.material_input input.enhanced-input').blur(function (){
    if(!this.value){
        $(this).removeClass('has-value');
        $(this).closest('.material-input').find('.icon_checkmark').remove();
    }else if (!$(this).hasClass('error')){
        $(this).addClass('has-value');
        $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
    }
});

$(document).on('change', '.fileupload-wrap .inputfile', function() { 
    var fileName = $(this).closest('.inputBtnSection').find('.inputfile').val();
    var idxDot = fileName.lastIndexOf('.') + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
    var configuredFileSize = $('.fileupload-wrap').attr('data-max-file-size');
    var configuredFileSizeKb = configuredFileSize * 1000;
    var size = parseFloat($(this).closest('.inputBtnSection').find('.inputfile')[0].files[0].size / 1024).toFixed(2);
    if (size >= configuredFileSizeKb) {
        $(this).parents('.fileupload-wrap').next('.error.file-validation').show();
        $(this).closest('.inputBtnSection').prev('.error-placement').remove();
        $(this).closest('.inputBtnSection').removeClass('appended');
        $(this).closest('.inputBtnSection').find('.narspro-input-upload').addClass('error');
        $(this).closest('.inputBtnSection').find('.inputfile').val('');
        $(this).closest('.inputBtnSection').find('.file-upload-display').remove();
    } else {
        if (extFile=='pdf' || extFile=='jpeg' || extFile=='png' || extFile=='jpg'){
            if ($(this).val().length) {
                if ($(this).closest('.inputBtnSection').find('span.file-upload-display').length) {
                    $(this).closest('.inputBtnSection').find('span.file-upload-display').html($(this).val().replace(/.*(\/|\\)/, '') + '<em class=\'icon icon-close\'></em>');
                } else {
                    $(this).closest('.inputBtnSection').find('span.fsizereg').after('<span class = \'file-upload-display\' >' + $(this).val().replace(/.*(\/|\\)/, '') + '<em class=\'icon icon-close\'></em>' + '</span>');
                }
                $(this).closest('.inputBtnSection').addClass('appended');
                $(this).closest('.inputBtnSection').find('.narspro-input-upload').removeClass('error');
                $(this).closest('.inputBtnSection').prev('.error-placement').remove();
                $(this).parents('.fileupload-wrap').next('.error.file-validation').hide();
            }
        } else {
            $(this).closest('.inputBtnSection').prev('.error-placement').remove();
            $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertBefore($(this).closest('.fileupload-wrap').find('.inputBtnSection'));
            $(this).closest('.inputBtnSection').removeClass('appended');
            $(this).closest('.inputBtnSection').find('.narspro-input-upload').addClass('error');
            $(this).closest('.inputBtnSection').find('.inputfile').val('');
            $(this).closest('.inputBtnSection').find('.file-upload-display').remove();
            $(this).parents('.fileupload-wrap').next('.error.file-validation').hide();
		
        }
    }
	
});

$(document).on('click','.file-upload-display .icon-close',function() {
    var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
    $(this).closest('.inputBtnSection').removeClass('appended');
    $(this).closest('.inputBtnSection').find('.narspro-input-upload').addClass('error');
    $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertBefore($(this).closest('.fileupload-wrap').find('.inputBtnSection'));
    $(this).closest('.inputBtnSection').find('input:file').val('');
    $(this).closest('.file-upload-display').remove();
});


$('.narspro-artistsignupform select').selectmenu({
    classes: {
        'ui-selectmenu-menu': 'qv-select'
    },
    icons: { 
        button: 'ui-icon-circle-triangle-s'
    }
});

validator.initStateValidation();
validator.initForm('form[id="nars-pro-signup-form"]');

$('.narspro-artistsignupform .np-next-step-button').on('click', function(e){
    var isError = false;
    $.each($('.enhancedinput-select select'), function() {
        validator.initgenericValidation($(this));
        if(isError == false){
            if($(this).hasClass('error')){
                isError = true;
            }
        }
    });
    $.each($('#nars-pro-signup-form .enhanced-input.required'), function(e) {
        validator.initinputValidation($(this));
        if(isError == false){
            if($(this).hasClass('error')){
                isError = true;
            }
        }
    });

    $.each($('.inputBtnSection'), function() {
        validator.initfileValidation($(this));
        if(isError == false){
            if($(this).find('.narspro-input-upload').hasClass('error')){
                isError = true;
            }
        }
    });

    $.each($('.input-checkbox.required'), function() {
        validator.initcheckboxValidation($(this));
        if(isError == false){
            if($(this).hasClass('error')){
                isError = true;
            }
        }
    });

    $(this).addClass('button-nonclickable');

    if(isError == true){
        e.preventDefault();
        $(this).removeClass('button-nonclickable');
    }
	
});

$('#nars-pro-signup-form .enhanced-input.required').on('blur', function(e){
    var customstateRow = $(this).parents('.enhancedinput-text').find('label:first');	
    var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
    if ($(e.target).val() === '') {
        $(this).addClass('error');
        customstateRow.next('.error-placement').remove();
        $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertAfter(customstateRow);
    } else {
        $(this).removeClass('error');
        customstateRow.next('.error-placement').remove();
    }
	
});

$('.narspro-artistsignupform .phone').on('input', function (event) { 
    this.value = this.value.replace(/[^0-9]/g, '');
});

$(document).on('change', '.narspro-artistsignupform .input-checkbox.required', function(){ 
    validator.initcheckboxValidation($(this));
});

var narspro = {
    init: function() {
        // -----------------------------------
	
        $(document).ready(function() {
            $('.privactual').html('<p>I have read your letter and assure you that in exchange for the benefits of the ' +
			'NARS PRO Program, products sold to me at discount will be used ' +
			'in professional activities exclusively and will not be resold. I understand that ' +
			'orders placed via this program on www.narscosmetics.com cannot be ' +
			'combined with any other discount, promotion or by using an "affiliate" link to ' +
			'earn commisions; and that orders made in-person at the NARS boutique ' +
			'cannot be combined with any other discount, and can only be made upon ' +
			'presentation of a registered Discount Card.</p>' +
			'<p class="lastp"><input class="ofage" type="checkbox" name="pp" value="chk" > I hereby certify that I am 18 years of age or older, and that I understand ' +
			'and agree to all the foregoing and hereby provide consent to NARS for the ' +
			'collection and use of my personal information for the purposes of the ' +
			'NARS PRO program. I understandand agree that the collection and use ' +
			'of such information is governed by the NARS <a href="'+Urls.NarsProPrivacy+'" target="_blank">Privacy Policy</a>.</p>' +
			'<div class="errMsgHere"></div>'
            );

            $('.inputUrlSection').hide();

            // initialize to first image
            $('#slideshow .bgM02').fadeTo(fadeMillis, 0.3); // eye
            $('#slideshow .bgM03').fadeTo(fadeMillis, 0);	// cheek
            $('#slideshow .bgM01').fadeTo(fadeMillis, 0);	// lipstick
            // show bg, based on pro level
            $('.bigAppHolder').mouseenter(function() {
                $('#slideshow img').stop(true); // clearQueue
                $('#slideshow .bgM01').fadeTo(fadeMillis, 0.3);
                $('#slideshow .bgM02').fadeTo(fadeMillis, 0);
                $('#slideshow .bgM03').fadeTo(fadeMillis, 0);
            });
            $('.bigIndHolder').mouseenter(function() {
                $('#slideshow img').stop(true); // clearQueue
                $('#slideshow .bgM02').fadeTo(fadeMillis, 0.3);
                $('#slideshow .bgM03').fadeTo(fadeMillis, 0);
                $('#slideshow .bgM01').fadeTo(fadeMillis, 0);
            });
            $('.bigArtHolder').mouseenter(function() {
                $('#slideshow img').stop(true); // clearQueue
                $('#slideshow .bgM03').fadeTo(fadeMillis, 0.3);
                $('#slideshow .bgM01').fadeTo(fadeMillis, 0);
                $('#slideshow .bgM02').fadeTo(fadeMillis, 0);
            });
		
            $(document).on('change', ':checkbox[name="UorM"]', function() {
                myOwnChk(this);
            });
		
            $(document).on('change', ':checkbox[name="pp"]', function() {
                clearPPError(this);
            });
		
            $(document).on('change', ':checkbox.chkAtt', function(){
                myAttChk(this);
            });
		
            $(document).on('click', '.subapd.fontB', function() {
                var param = $(this).attr('data-param');
                trySubmit(this, param);
            });

        }); /* end (document).ready() */
	
        //Display Nars Pro Signup Success Popup
        if($('.narspro-signup-success-wrapper').length > 0){
	    	var popup = new Foundation.Reveal($('.narspro-signup-success-container'));
	    	popup.open();
	    	
	    	$('.narspro-signup-ok').on('click', function(){
	    		document.location.href = Urls.homeShow;
	    	});
	    	modal.events.onClose(function () {
	    		document.location.href = Urls.homeShow;
	    	});
        }
    }
}

export default narspro;